import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import media from '../../utils/mediaQueries';

import Btn from '../buttons/Btn';
import Clipboard from '../../utils/clipboard';
import { MAIN_BLUE } from '../../theme';

const copyButtonTexts = {
  normal: 'Copier le lien',
  coppied: 'Lien copié',
};

const Modal = styled.div`
  position: absolute;
  bottom: -110px;
  right: 0;
  background: #ffffff;
  z-index: 100;
  padding: 20px 24px 12px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.02),
    0 2px 4px 0 rgba(155, 132, 135, 0.06), 0 4px 12px 0 rgba(119, 94, 98, 0.05);
  ${media.mobile`
    width: 100%;
    bottom: -110px;
  `}
`;

const CloseButton = styled.button`
  width: 18px;
  height: 18px;
  position: absolute;
  top: 8px;
  right: 8px;
  background: none;
  padding: 0;
  outline: none;
  border-radius: 50%;
  border: 1px solid #ffffff;
  &:focus {
    border-color: #b7c2ce;
  }
`;

const Title = styled.div`
  font-size: 16px;
  color: #354354;
  margin-bottom: 4px;
`;

const Input = styled.input`
  width: 400px;
  border: none;
  background: transparent;
  font-size: 14px;
  color: ${({ isAvisSolution }) => isAvisSolution ? '#313b82' : MAIN_BLUE};
  margin-bottom: 8px;
  outline: none;
  ${media.mobile`
    width: 100%;
  `}
`;

class ShareLink extends Component {
  constructor(props) {
    super(props);

    this.textInput = React.createRef();
    this.state = {
      isCoppied: false,
    };
  }

  copyToClipboard = () => {
    Clipboard.selectText(this.textInput.current);
    Clipboard.copyToClipboard();

    this.setState({
      isCoppied: true,
    });

    const timer = setTimeout(() => {
      this.setState({
        isCoppied: false,
      });
      clearTimeout(timer);
    }, 2000);
  };

  render() {
    const {
      reviewId, isSchool, onClose, isAvisSolution,
    } = this.props;
    const { isCoppied } = this.state;
    const hostUrl = document.location.origin;

    return (
      <Modal>
        <CloseButton onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <path
              fill="#CCD0D4"
              d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm2.924 5.062a.545.545 0 0 0-.771 0l-2.07 2.153-2.25-2.182a.545.545 0 1 0-.757.785l2.237 2.153-2.237 2.153a.545.545 0 1 0 .757.785l2.25-2.182 2.07 2.153a.545.545 0 1 0 .785-.756L8.855 7.942l2.083-2.182a.545.545 0 0 0-.014-.698z"
            />
          </svg>
        </CloseButton>
        <Title>Partagez cet avis en copiant le lien ci-dessous</Title>
        <Input
          type="text"
          readonly
          ref={this.textInput}
          defaultValue={`${hostUrl}/${isSchool ? 'avis' : 'avis-code-de-la-route'}/${reviewId}${isAvisSolution ? '?partner=avis-solution' : ''}`}
          isAvisSolution={isAvisSolution}
        />
        <Btn
          type="button"
          small
          text={isCoppied ? copyButtonTexts.coppied : copyButtonTexts.normal}
          onClick={this.copyToClipboard}
          color={isAvisSolution ? '#313b82' : MAIN_BLUE}
        />
      </Modal>
    );
  }
}

ShareLink.propTypes = {
  reviewId: PropTypes.string,
  onClose: PropTypes.func,
  isSchool: PropTypes.bool,
  isAvisSolution: PropTypes.bool,
};

ShareLink.defaultProps = {
  reviewId: '',
  onClose: () => {},
  isSchool: true,
  isAvisSolution: false,
};

export default ShareLink;
